import { render } from "./CarouselSlide.vue?vue&type=template&id=0be3b8f1"
const script = {}

import "./CarouselSlide.vue?vue&type=style&index=0&id=0be3b8f1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__